<template>
  <div
    class="songs-item"
    :current="current === index"
    @click="on_song_item_click"
  >
    <div class="icon-box">
      <div v-if="current === index && isPlaying" class="current_play_box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <v-icon v-else class="play_arrow">play_arrow</v-icon>
    </div>
    <span class="item-title">{{ obj.title }}</span>
    <span class="duration">{{ obj.duration }}</span>
  </div>
</template>

<script>
import "./index.scss";
export default {
  name: "songs-item",
  props: {
    current: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    obj: {
      type: Object,
      required: true,
    },
    isPlaying: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    on_song_item_click() {
      this.$emit("songClick", this.index);
    },
  },
};
</script>
